
import { defineComponent } from "vue";
import KycVerificationInfomation from "@/components/page/kyc/kyc-verification/Information.vue";

export default defineComponent({
  name: "kyc-verification-natural-person-information",
  components: {
    KycVerificationInfomation,
  },
  setup() {
    return {};
  },
});
